'use strict';

var d3 = require('d3');

/**
 * Vertical Brush
 *
 * Allows to make a selection along with the y axis
 *
 * @param d3Helper
 * @returns {Function}
 * @constructor
 */
var VerticalBrush = function VerticalBrush(d3Helper) {
  return function () {
    var scales, params;
    var brushGroup, svgBrush;
    var dispatch = d3.dispatch('brushchange');
    function getSvgBrush() {
      var svgBrush = d3.svg.brush();
      svgBrush.on('brush', brush.brushHandler);
      return svgBrush;
    }
    var brush = function brush(container) {
      svgBrush = svgBrush || getSvgBrush();
      svgBrush.y(scales.yScale);
      brushGroup = d3Helper.createGroupElement(container, 'vertical-brush');
      brushGroup.call(svgBrush);
      brushGroup.selectAll('rect').attr('x', 0).attr('width', params.width);
    };
    brush.brushHandler = function () {
      dispatch.brushchange(svgBrush.extent());
    };
    brush.getSelection = function () {
      return svgBrush.extent();
    };
    brush.scales = function (value) {
      scales = value;
      return brush;
    };
    brush.params = function (value) {
      params = value;
      return brush;
    };
    return d3.rebind(brush, dispatch, 'on');
  };
};
VerticalBrush.$inject = ['d3Helper'];
module.exports = VerticalBrush;